
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donors",
      function () {
        return require("private-next-pages/donors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/donors"])
      });
    }
  